import { DateTime } from 'luxon'

import { SERIES_CHATS_CLOSE_AFTER_DAYS } from './constants'

export function getSeriesChatsCloseDate(endDate: Date): DateTime {
  return DateTime.fromJSDate(endDate).plus({ days: SERIES_CHATS_CLOSE_AFTER_DAYS })
}
